<template>
  <div>
    <div>
      <h6 class="text-subtitle-1 text-md-h6 font-weight-bold">
        Servicios a facturar
      </h6>
      <p
        class="text-subtitle-2 text-md-subtitle-1 font-weight-regular grey--text text--darken-1"
      >
        Seleccioná los servicios que vayas a incluir en esta factura.
      </p>
    </div>
    <SkeletonForm v-if="isLoading" />
    <main
      v-else-if="!isLoading && pendingTransactions"
      class="d-flex flex-column"
    >
      <v-checkbox
        v-model="selectAll"
        color="blue darken-2"
        style="width: fit-content"
        class="pl-3 pl-md-6"
        label="Seleccionar todos"
        @change="toggleSelectedAll"
      ></v-checkbox>
      <section class="d-flex flex-column mt-0 mb-5" style="gap: 0.5rem">
        <v-card
          v-for="transaction of pendingTransactions"
          :key="transaction.id"
          style="border-left: 8px solid #ff9800"
        >
          <v-row class="d-flex align-center mr-1 mr-md-0">
            <v-col
              cols="8"
              sm="8"
              md="8"
              class="pl-1 pr-0 pr-md-3 d-flex align-center"
            >
              <v-checkbox
                :value="transaction"
                v-model="formData.transactions"
                class="ml-3 ml-md-6"
                color="blue darken-2"
                @change="v.transactions.$touch()"
              ></v-checkbox>
              <v-card-text class="d-flex flex-column px-0">
                <span class="text-subtitle-1 text-md-h6 font-weight-medium">{{
                  transaction.service
                }}</span>
                <span
                  class="text-subtitle-2 grey--text text--darken-1 font-weight-regular"
                  >Pedido {{ transaction.request_id }}</span
                >
              </v-card-text>
            </v-col>
            <v-col cols="4" sm="4" md="4" class="px-0 px-md-3">
              <div class="d-flex flex-column text-end">
                <h6
                  class="text-subtitle-1 text-md-h6 font-weight-medium grey--text text--darken-1 short-text"
                >
                  $ {{ transaction.amount }}
                </h6>
                <span
                  v-if="transaction.paid"
                  style="text-wrap: nowrap; position: relative"
                  class="green--text text-subtitle-2"
                  ><v-icon
                    small
                    color="green"
                    style="position: absolute; right: 100px; top: 3px"
                    >error_outlined</v-icon
                  >
                  Cobrado el {{ transaction.paid }}</span
                >
              </div>
            </v-col>
          </v-row>
        </v-card>
      </section>

      <p
        v-if="v.transactions.$error"
        class="subtitle-1 red--text darken-4 font-weight-medium"
      >
        {{ transactionErrors[0] }}
      </p>

      <div class="pl-5 pl-md-15 pr-2 pr-md-8">
        <p
          class="text-uppercase text-subtitle-1 text-md-h6 font-weight-medium d-flex justify-space-between mb-2"
        >
          total a facturar:
          <span class="grey--text text--darken-1"
            >$ {{ totalAmountAll }}.00</span
          >
        </p>
        <p
          class="text-uppercase text-subtitle-1 text-md-h6 font-weight-medium green--text d-flex justify-space-between mb-5"
        >
          total a cobrar: <span>$ {{ totalAmountWithoutPaid }}.00</span>
        </p>
      </div>
    </main>
  </div>
</template>

<script>
import SkeletonForm from "@/components/SkeletonForm.vue";
import { mapActions, mapState } from "vuex";

export default {
  name: "FirstStep",
  props: {
    formData: {
      type: Object,
      required: true,
    },
    v: {
      type: Object,
      required: true,
    },
  },
  components: { SkeletonForm },
  data: () => ({
    selectAll: false,
  }),
  computed: {
    ...mapState("invoice", ["pendingTransactions", "isLoading"]),

    transactionErrors() {
      const errors = [];
      if (!this.v.transactions.$error) return errors;
      !this.v.transactions.required && errors.push("Este campo es obligatorio");
      !this.v.transactions.minLength &&
        errors.push("Debe seleccionar al menos una transacción");
      return errors;
    },
    allTransactionSelected() {
      return (
        this.formData.transactions.length === this.pendingTransactions.length
      );
    },
    totalAmountAll() {
      return this.formData.transactions.reduce(
        (total, transaction) => total + Number(transaction.amount),
        0
      );
    },
    totalAmountWithoutPaid() {
      return this.formData.transactions.reduce((total, transaction) => {
        if (!transaction.paid) {
          return total + Number(transaction.amount);
        }
        return total;
      }, 0);
    },
  },
  async created() {
    await this.getPendingTransactions();
  },
  methods: {
    ...mapActions("invoice", ["getPendingTransactions"]),
    toggleSelectedAll(selected) {
      if (selected) {
        for (const transaction of this.pendingTransactions) {
          const findTransaction = this.formData.transactions.find(
            (t) => t.id === transaction.id
          );

          if (!findTransaction) {
            this.formData.transactions.push(transaction);
          }
        }
      } else {
        this.formData.transactions = this.formData.transactions.filter(
          (transaction) =>
            !this.pendingTransactions.some((t) => t.id === transaction.id)
        );
      }
    },
  },
  watch: {
    allTransactionSelected: {
      handler(newValue) {
        if (newValue) {
          this.selectAll = true;
        } else {
          this.selectAll = false;
        }
      },
      immediate: true,
    },
  },
};
</script>
<style scoped>
@media (max-width: 959px) {
  .short-text {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
}
</style>
